import script from "./LineConfigManage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LineConfigManage.vue?vue&type=script&setup=true&lang=ts"

import "./LineConfigManage.vue?vue&type=style&index=0&id=344b47d5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-344b47d5"]])

export default __exports__